import { render, staticRenderFns } from "./MessagingContainer.vue?vue&type=template&id=09ecf55a&scoped=true"
import script from "./MessagingContainer.vue?vue&type=script&lang=ts"
export * from "./MessagingContainer.vue?vue&type=script&lang=ts"
import style0 from "./MessagingContainer.vue?vue&type=style&index=0&id=09ecf55a&prod&lang=scss&scoped=true"
import style1 from "./MessagingContainer.vue?vue&type=style&index=1&id=09ecf55a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ecf55a",
  null
  
)

export default component.exports